import React from 'react';
import ReactDOM from 'react-dom';
import "@babel/polyfill";
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

const root = document.getElementById('our-services');
const title = root ? (root.getAttribute('title') || 'default') : 'default';
const itemsString = root ? (root.getAttribute('items') || '[]') : '[]';
const items = JSON.parse(itemsString);

ReactDOM.render(<App items={items} title={title}/>, root);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js